<template>
  <div class="main-body">
    <div style="height: 60px"></div>

    <div class="main-0" id="page1">
      <el-carousel :interval="4000" type="card" height="500px" arrow="never">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <el-image
            class="animated bounceInDown"
            style="width: 100%; height: 100%"
            :src="item.url"
          >
          </el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="about-section" id="aboutSection">
      <div class="container">
        <div class="grid">
          <div class="image-container">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/170ec1e4fe27b6bd589c1a1adfe0c9b8.jpg"
              alt="Office Environment"
            />
          </div>
          <div class="text-content">
            <h2 class="title">关于德财软件</h2>
            <div class="description">
              <p>
                广州市德财软件有限公司成立于 2016 年 9 月 14
                日，是一家专注于软件开发、信息技术服务及电子通信技术研发的高新技术企业。公司致力于为客户提供专业的软件解决方案、网络技术支持及信息技术咨询服务，助力企业数字化升级和技术创新。
              </p>
              <p>
                自成立以来，广州市德财软件有限公司已为众多行业客户提供优质的技术支持，涵盖软件开发、软件测试、信息电子技术研究、计算机技术服务等领域。凭借专业的技术团队和丰富的行业经验，公司不断推动技术进步，优化业务流程，为客户创造更大的价值。与此同时，公司还积极拓展国际市场，提供技术进出口服务，促进全球技术交流与合作。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="core-values" id="coreValues">
      <div class="value-container">
        <h2 class="title">核心价值观</h2>
        <div class="value-grid">
          <div class="value-card">
            <div class="icon-box">
              <i class="iconfont icon-cxqd" style="scale: 2.5"></i>
            </div>
            <h3 class="value-title">创新驱动</h3>
            <p class="value-text">
              持续探索技术前沿，推动行业创新发展，为客户创造更多价值。
            </p>
          </div>
          <div class="value-card">
            <div class="icon-box">
              <i class="iconfont icon-xzgy" style="scale: 1.8"></i>
            </div>
            <h3 class="value-title">协作共赢</h3>
            <p class="value-text">注重团队协作，与客户建立长期伙伴关系，实现互利共赢。</p>
          </div>
          <div class="value-card">
            <div class="icon-box">
              <i class="iconfont icon-zypz" style="scale: 2.5"></i>
            </div>
            <h3 class="value-title">卓越品质</h3>
            <p class="value-text">追求技术卓越，确保服务品质，持续提升客户满意度。</p>
          </div>
        </div>
      </div>
    </div>

    <section class="section-padding section-bg" id="page2">
      <div class="grid-section">
        <div class="flex-layout" id="page2-animation">
          <div class="content-wrapper">
            <h2>智慧美业管理系统</h2>
            <p class="section-description">
              为美容美发行业打造的一站式解决方案，助力门店数字化转型升级,提升运营效率和服务质量。系统功能涵盖客户关系管理、预约排程、库存管理、营销自动化等多个方面，通过智能化的技术手段，为美业企业提供全方位的数字化支持，助力企业提升竞争力，实现业务的可持续发展。
            </p>
            <div class="feature-grid"></div>
            <button class="button primary-button" @click="navigateToDetail('Tyd')">
              查看详情
            </button>
          </div>
          <div class="image-wrapper">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/7eb605eb0b5dbe53126d7013c57e67ae.jpg"
              class="section-image"
              alt="美容美发"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding section-bg" id="page3">
      <div class="grid-section">
        <div class="flex-layout" id="page3-animation">
          <div class="image-wrapper">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/60a13fa126d79883faebf428a16513d8.jpg"
              class="section-image"
              alt="智慧物业"
            />
          </div>
          <div class="content-wrapper">
            <h2>智慧物业</h2>
            <p class="section-description">
              为物业管理行业设计的智能化管理平台。通过整合物联网、大数据和人工智能技术，实现对物业设施的智能化监控与管理。系统功能包括社区安防监控、设施设备管理、物业费用收缴、业主服务请求处理等。智慧物业系统能够提升物业管理的效率和质量，降低运营成本，同时为用户提供更加便捷、高效的服务体验。
            </p>
            <div class="feature-grid"></div>
            <button class="button primary-button" @click="navigateToDetail('Smartrent')">
              查看详情
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding section-bg" id="page4">
      <div class="grid-section">
        <div class="flex-layout" id="page4-animation">
          <div class="content-wrapper">
            <h2>聚支付平台</h2>
            <p class="section-description">
              整合多种支付渠道的综合支付解决方案。平台支持包括银行卡支付、移动支付、数字钱包等多种支付方式，为企业提供一站式的支付接入服务。聚支付平台具有高安全性、高稳定性和高扩展性的特点，能够满足不同规模企业的支付需求，帮助企业快速实现多元化支付功能，提升收款效率和资金管理能力。
            </p>
            <div class="feature-grid"></div>
            <button
              class="button primary-button"
              @click="navigateToDetail('Gatherwealth')"
            >
              查看详情
            </button>
          </div>
          <div class="image-wrapper">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/63d8cd2227178d5ec845bd97460d4290.jpg"
              class="section-image"
              alt="聚支付平台"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding section-bg" id="page5">
      <div class="grid-section">
        <div class="flex-layout" id="page5-animation">
          <div class="image-wrapper">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/0859c1ee82ce7deef96d567454c2aa9f.jpg"
              class="section-image"
              alt="短信平台"
            />
          </div>
          <div class="content-wrapper">
            <h2>短信平台</h2>
            <p class="section-description">
              为企业提供稳定可靠短信服务的通信平台。平台基于AI智能调度和多通道负载均衡技术，支持营销、验证码、通知等多种业务场景。系统具备99.99%的高到达率保障，实时数据监控分析，智能防骚扰过滤等功能，确保企业通信的安全、高效与合规。短信平台配备完整的短信管理后台，支持模板定制、批量发送、智能调度等多项核心功能，助力企业快速触达目标用户。
            </p>
            <div class="feature-grid"></div>
            <button class="button primary-button" @click="navigateToDetail('Message')">
              查看详情
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding section-bg" id="page6">
      <div class="grid-section">
        <div class="flex-layout" id="page6-animation">
          <div class="content-wrapper">
            <h2>营销平台</h2>
            <p class="section-description">
              美容经营管理系统是一套专为美容美发连锁量身打造的一体化数字营销平台，将会员、员工、门店与总部紧密连接：通过小程序和企业微信提供营销、服务、学习、打卡等便捷工具；集中管理会员周期、项目销售、成本控制与盈亏分析，用数据驱动决策，实现规模化、精细化、智能化的持续运营与增长。
            </p>
            <div class="feature-grid"></div>
            <button class="button primary-button" @click="navigateToDetail('Marketing')">
              查看详情
            </button>
          </div>
          <div class="image-wrapper">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/0859c1ee82ce7deef96d567454c2aa9f.jpg"
              class="section-image"
              alt="营销平台"
            />
          </div>
        </div>
      </div>
    </section>

    <div class="main-suspension animated bounceInRight">
      <!-- <div class="main-suspension-abs animated pulse" @click="dialogVisible = true">
        <i class="iconfont icon-ruzhuchenggongdapx"></i><br />
        <span>注册开店</span>
      </div> -->
      <!-- <el-popover placement="left" style="text-align: center" trigger="hover">
        <img :src="imgUrl + 'img/Rentapp.png'" style="width: 150px" />
        <div slot="reference">
          <a target="_blank" :href="imgUrl + 'dcmy.apk'">
            <div class="main-suspension-abs">
              <i class="iconfont icon-app"></i><br />
              <span>APP下载</span>
            </div>
          </a>
        </div>
      </el-popover> -->
      <!-- <el-popover placement="left" style="text-align: center" trigger="hover">
        <div>微信搜索小程序 DCMY</div>
        <img :src="imgUrl + 'img/wx-DCMY.png'" style="width: 150px" />
        <div slot="reference">
          <div class="main-suspension-abs">
            <i class="iconfont icon-xiaochengxu"></i><br />
            <span>小程序</span>
          </div>
        </div>
      </el-popover> -->
      <!-- <el-popover
        placement="left"
        title="微信扫码添加"
        style="text-align: center"
        trigger="hover"
      >
        <img :src="imgUrl + 'img/er.png'" style="width: 150px" />
        <div class="main-suspension-abs" slot="reference">
          <i class="iconfont icon-weixin"></i><br />
          <span>官方微信</span>
        </div>
      </el-popover> -->
      <a @click="upHeader" class="back-to-top">
        <div class="main-suspension-abs">
          <i class="iconfont icon-huidaodingbu"></i>
          <!-- <br /> -->
          <!-- <span>回到顶部</span> -->
        </div>
      </a>
    </div>
    <el-dialog
      title="注册开店"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <base-store v-on:dialog="dialogs"></base-store>
    </el-dialog>
    <el-dialog title="查看大图" :visible.sync="baseDialogVisible" width="1200px">
      <el-image v-show="imgIndex != 99" class="images" :src="images"></el-image>
      <div v-show="imgIndex == 99" style="width: 100%; text-align: center">
        微信扫码添加
      </div>
      <el-image
        v-show="imgIndex == 99"
        style="width: 500px; height: 500px; margin: 0 350px"
        :src="images"
      >
      </el-image>
    </el-dialog>

    <el-dialog title="查询注册信息" :visible.sync="queryDialog">
      <el-form style="padding-left: 50px" inline>
        <el-form-item label="手机号">
          <el-input
            style="width: 260px"
            v-model="registrantMobilePhone"
            maxlength="11"
            class="input-with-select"
          >
            <el-button
              size="mini"
              type="success"
              slot="append"
              icon="el-icon-search"
              @click="query"
            >
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="门店业务" label-width="120px">
          <el-link
            href="https://www.decaisoft.com:9076/#/login"
            :underline="false"
            type="primary"
          >
            点击打开网站
          </el-link>
        </el-form-item> </el-form
      ><br />
      <el-table :data="tableList">
        <el-table-column
          label="注册时间"
          align="center"
          prop="funderDate"
          min-width="150"
        >
        </el-table-column>
        <el-table-column label="注册人" align="center" prop="registrant" min-width="100">
        </el-table-column>
        <el-table-column
          label="手机号"
          align="center"
          prop="registrantMobilePhone"
          min-width="100"
        >
        </el-table-column>
        <el-table-column label="门店名称" align="center" prop="storeName" min-width="100">
        </el-table-column>
        <el-table-column label="当前状态" align="center" prop="state" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state == 1 ? 'success' : 'danger'">
              {{ scope.row.state == 1 ? "审核已通过" : "审核中" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="省/市/区"
          align="center"
          prop="funderDate"
          min-width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.province + " / " + scope.row.city + " /  " + scope.row.county }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="mini" @click="queryDialog = false" plain>
          关 闭
        </el-button>
      </span>
    </el-dialog>
    <el-dialog title="联系我们" :visible.sync="delDialog" class="lxdialog">
      <el-form :model="delForm">
        <el-form-item label="联系方式:">
          <span>{{ delForm.name }} - {{ delForm.mobilePhone }}</span>
        </el-form-item>
        <el-form-item label="公司地址:">
          <span>{{ delForm.adress }} </span>
        </el-form-item>
        <baidu></baidu>
        <!--   <el-form-item label="">
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="mini" @click="delDialog = false" plain>
          关 闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseStore from "./baseStore/baseStore.vue";
import baseRests from "./baseStore/baseRests";
import baidu from "./baiduMap/baidu.vue";
import but from "./but.js";
import { gethttps, getImageUrl } from "../../utils/utils.js";
import { storepage, imgPage } from "../../api/api";
export default {
  components: {
    baseStore,
    baidu,
  },
  data() {
    return {
      imgUrl: getImageUrl(),
      delForm: {
        name: "吴生",
        mobilePhone: 18902223487,
        adress: "广东省广州市天河区羊城国际商贸中心",
      },
      storeList1: [],
      storePreviewList1: [],
      storePreviewList2: [],
      storeList2: [],
      appList: [],
      wxList: [],
      images: null,
      imgIndex: 1,
      tableList: [],
      list: ["https://www.decaisoft.com:443/img/demay/img/01.png"],
      baseDialogVisible: false,
      dialogVisible: false,
      registrantMobilePhone: null,
      queryDialog: false,
      delDialog: false,
      title: "查询审核结果",
      srcList: [
        "../../assets/01.png",
        "../../assets/02.png",
        "../../assets/03.png",
        "../../assets/001.png",
      ],
      src: "../../assets/01.jpg",
      swiperList: [
        {
          // url: require("@/assets/imageList/imageOne.jpg"),
          url:
            "https://ai-public.mastergo.com/ai/img_res/b4ea8de3b204ce4b3cbc0fc8bdc1598a.jpg",
        },
        {
          // url: require("@/assets/imageList/imageTwo.jpg"),
          url:
            "https://ai-public.mastergo.com/ai/img_res/95edb3ca5f01cb9f52d160d7930ecf99.jpg",
        },
        {
          // url: require("@/assets/imageList/imageThree.jpg"),
          url:
            "https://ai-public.mastergo.com/ai/img_res/38ddcf8f30add9b690b465626f402ed2.jpg",
        },
        {
          // url: require("@/assets/imageList/imageFour.jpg"),
          url:
            "https://ai-public.mastergo.com/ai/img_res/9d7feda785bd9261f3f0d9fb6df3e314.jpg",
        },
        {
          // url: require("@/assets/imageList/imageFive.jpg"),
          url:
            "https://ai-public.mastergo.com/ai/img_res/6528eee58a5688e890114795e4ad153d.jpg",
        },
      ],
      imageLisrt1: [
        {
          url: "../../assets/01.jpg",
        },
        {
          url: "../../assets/02.jpg",
        },
        {
          url: "../../assets/03.jpg",
        },
      ],
      pageIds: null,
    };
  },
  created() {
    // this.imgPage();
    var that = this;
    but.$on("key", function (key) {
      if (key <= 3) {
        var PageId = document.querySelector("#page" + key);
        window.scrollTo({
          top: PageId.offsetTop - 120,
          behavior: "smooth",
        });
      } else {
        if (key * 1 == 51) {
          that.queryDialog = true;
          that.qureyForm = {};
          that.registrantMobilePhone = null;
        }
        if (key * 1 == 52) {
          that.queryDialog = true;
          that.qureyForm = {};
          that.registrantMobilePhone = null;
        }
        if (key * 1 == 4) {
          that.dialogVisible = true;
        }

        if (key * 1 == 99) {
          that.delDialog = true;
        }
      }
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    // this.setupAnimationObserver();
    window.addEventListener("scroll", function () {
      const backToTop = document.querySelector(".back-to-top");
      if (window.scrollY > 300) {
        backToTop.classList.add("show-back-to-top");
      } else {
        backToTop.classList.remove("show-back-to-top");
      }
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  methods: {
    dialogs: function (dialog) {
      this.dialogVisible = dialog;
    },
    query() {
      let that = this;
      let phoneNum = /^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/;
      if (phoneNum.test(that.registrantMobilePhone)) {
        storepage({
          registrantMobilePhone: that.registrantMobilePhone,
        }).then((res) => {
          if (res.code == "000000") {
            that.tableList = res.pageInfo.list;
            that.$message.success({
              message: res.message,
            });
          } else {
            that.$alert(res.message, "提示", {
              confirmButtonText: "确定",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
          }
        });
      } else {
        that.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
          callback: (action) => {},
        });
      }
    },
    confirm() {},
    skip(key) {
      var PageId = document.querySelector("#page" + key);
      this.pageIds = PageId;
      window.scrollTo({
        top: PageId.offsetTop - 120,
        behavior: "smooth",
      });
    },
    navigateToDetail(route) {
      switch (route) {
        case "Tyd":
          this.$router.push("/Tyd");
          break;
        case "Smartrent":
          this.$router.push("/Smartrent");
          break;
        case "Gatherwealth":
          this.$router.push("/Gatherwealth");
          break;
        case "Message":
          this.$router.push("/Message");
          break;
        case "Marketing":
          this.$router.push("/Marketing");
        default:
          break;
      }
      sessionStorage.setItem("route", route);
    },
    // 回到顶部
    upHeader() {
      // var PageId = document.querySelector("#page1");
      var PageId = document.querySelectorAll(".main-body");
      window.scrollTo({
        top: PageId.offsetTop - 120,
        behavior: "smooth",
      });
    },
    imgPage() {
      var page = {
        pageSize: 200,
        pageNum: 1,
        type: 0,
      };
      var swiperList = [];
      var storeList1 = [];
      var storeList2 = [];
      var appList = [];
      var wxList = [];
      var storePreviewList1 = [];
      var storePreviewList2 = [];
      imgPage(page).then((res) => {
        if (res.code == "000000") {
          res.pageInfo.list.forEach((item) => {
            item.url = gethttps() + item.filePath + item.fileName;
            if (item.type == 2) {
              storeList1.push(item);
              storePreviewList1.push(item.url);
            } else if (item.type == 3) {
              appList.push(item);
            } else if (item.type == 4) {
              wxList.push(item);
            } else if (item.type == 5) {
              storeList2.push(item);
              storePreviewList2.push(item.url);
            } else {
              if (item.url.indexOf("swiper") !== -1) {
                swiperList.push(item);
              }
            }
          });
          if (swiperList.length != 0) {
            this.swiperList = swiperList.sort();
          }
          this.storeList1 = storeList1.sort();
          this.storeList2 = storeList2.sort();
          this.appList = appList.sort();
          this.wxList = wxList.sort();
          this.storePreviewList1 = storePreviewList1;
          this.storePreviewList2 = storePreviewList2;
        } else {
        }
      });
    },
    handleScroll: function () {
      /*
        let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // 设备/屏幕高度
        let scrollObj = document.getElementById('animate_1'); // 滚动区域
        let scrollTop = $(scrollObj).offset().top; // animate_1 到头部的距离
      */
      let scrollHeight = $(window).scrollTop(); // 滚动条的滚动行程

      //滚动条滚动到对应的板块显示
      //导航栏背景色
      // if(scrollHeight < 70){
      //   $("#menubgfff").css('background','none');
      // }
      // if(scrollHeight > 70){
      //   $("#menubgfff").css('background','#FFF');
      // }
      //console.log(scrollHeight);

      if (scrollHeight > 45) {
        // $("#animate_1").addClass('animated bounceInDown');
      }
      if (scrollHeight > 552) {
      }
      if (scrollHeight > 1186) {
      }
    },
    setupAnimationObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const element = entry.target;
            if (entry.isIntersecting) {
              // 根据不同的区块应用不同的动画
              if (element.classList.contains("about-section")) {
                element.style.animation = "fadeIn 1s forwards";
              } else if (element.classList.contains("core-values")) {
                element.style.animation = "slideIn 1s forwards";
              } else if (element.classList.contains("section-padding")) {
                element.style.animation = "fadeIn 1s forwards";
              }
            } else {
              element.style.animation = "none";
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      // 观察每个需要动画的区块
      const animatedSections = document.querySelectorAll(
        ".about-section, .core-values, .section-padding"
      );
      animatedSections.forEach((section) => {
        observer.observe(section);
      });
    },
  },
};
</script>

<style scoped>
body {
  /* background-image: url(../../assets/beijing.jpg); */
  /* background-size: 100%; */
  background: white;
}

.main-body .el-dialog {
  margin-top: 10vh !important;
  min-width: 1000px;
}

.main-body {
  margin-top: 10px;
  /* background: rgb(250, 249, 249); */
  font-family: "宋体";
}

.main-body p {
  font-family: "幼圆";
}

.el-main {
  padding: 0;
}

.main-0 {
  margin-top: 30px;
  text-align: center;
  padding: 0 10px;
}

.main-1 {
  text-align: center;
  border-bottom: 10px solid rgb(100, 176, 247);
  padding: 20px 0;
  font-family: "幼圆";
}
.main-1 p {
  font-size: 20px;
  font-weight: 700;
  color: #444;
}
.main-1 h1 {
  font-size: 30px;
  font-weight: 900;
}

.main-suspension {
  position: fixed;
  right: 30px;
  top: 80%;
  /* top: 44%; */
  z-index: 999;
}

.main-suspension-abs {
  /* width: 80px; */
  /* height: 70px; */
  width: 50px;
  height: 50px;
  border: 1px solid rgb(190, 190, 190);
  /* box-shadow: 5px 5px 8px rgb(201, 201, 201); */
  background: rgb(250, 237, 237);
  opacity: 0.7;
  text-align: center;
  /* padding-top: 10px; */

  line-height: 50px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 0px 4px rgba(180, 160, 255, 0.253);
}

.main-suspension-abs i {
  font-size: 28px;
  display: inline-block;
  margin-bottom: 5px;
}

.main-1 .el-image:hover {
  transform: scale(1.1);
  animation: sca 1s;
}

@keyframes sca {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.el-main-1 .el-image:active {
  transform: scale(2);
}

.main-active {
  width: 60%;
  height: 150px;
  margin: 5px auto;
  /* box-shadow: 5px 5px 10px #CCCCCC; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-active-body:hover {
  box-shadow: 5px 5px 5px #ccc;
  cursor: pointer;
}

.main-active-body {
  /* width: 180px; */
  height: 100px;
  background: #f4f4f4;
  border: 1px solid #f1f1f1;
  border-radius: 25px;
  margin: 0 50px;
  font-size: 34px;
  box-shadow: 1px 1px 1px #ccc;
  /* color: white; */
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "幼圆";
}

.main-active-body span {
  margin: 0 10px;
  font-weight: 900;
  width: 140px;
}

.main-active-body i {
  text-align: center;
  font-size: 46px;
  color: #149fce;
  font-weight: 900;
}

.images {
  width: 1150px;
  height: 575px;
}

.images:active {
  margin-top: 10px;
  transform: scale(1.6);
}

.fleximage {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.lxdialog .el-form-item__content {
  font-size: 19px;
  font-weight: 700;
  color: #888;
}

.lxdialog .el-form-item__label {
  font-size: 20px;
  font-weight: 700;
  color: black;
}

.image-size {
  margin: 15px;
  height: 180px;
  width: 80px;
  border: #93e4ff 1px solid;
  border-radius: 5px;
}

.image-size-s {
  border: #93e4ff 1px solid;
  margin: 15px;
  border-radius: 5px;
  width: 150px;
  height: 75px;
}
</style>

<style scoped>
.section-padding {
  padding: 80px 0;
  margin-bottom: 20px;
}

.section-bg {
  background-color: #f9fafb;
}

@keyframes floatUp {
  from {
    transform: translateY(120px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes flyInLeft {
  from {
    transform: translateX(-120px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes flyInRight {
  from {
    transform: translateX(120px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.button {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.primary-button {
  background: #2563eb;
  color: white;
}

.primary-button:hover {
  /* background: #1d4ed8; */
}

.secondary-button {
  background: transparent;
  color: #2563eb;
}

#page2-animation {
  animation: floatUp 1s ease forwards;
}

#page3-animation {
  animation: flyInLeft 1s ease forwards;
}

#page4-animation {
  animation: flyInRight 1s ease forwards;
}

#page5-animation {
  animation: flyInLeft 1s ease forwards;
}

#page6-animation {
  animation: flyInRight 1s ease forwards;
}

.grid-section {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.flex-layout {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.content-wrapper h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #1f2937;
}

.section-description {
  font-size: 16px;
  color: #4b5563;
  margin-bottom: 32px;
  line-height: 1.6;
}

.image-wrapper,
.content-wrapper {
  width: 50%;
}

.image-wrapper img {
  width: 580px;
  object-fit: cover;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
}

@media (min-width: 768px) {
  .flex-layout {
    flex-direction: row;
    align-items: center;
  }

  .image-wrapper,
  .content-wrapper {
    /* width: 50%; */
  }
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.about-section {
  padding: 5rem 0;
  background-color: #f8fafc;
  margin-bottom: 20px;
}

.container {
  max-width: 85%;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.grid {
  /* display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem; */

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.text-content {
  color: #4b5563;
}

.title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1f2937;
}

.description p {
  line-height: 1.75;
  margin-bottom: 1rem;
}

.image-container {
  position: relative;
  width: 90%;
  height: 400px;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 核心价值观 */
.core-values {
  padding: 80px 0;
  background-color: #fff;
  text-align: center;
  margin-bottom: 20px;
}

.value-container {
  width: 80%;
  margin: 0 auto;
  background-color: #fff;
}

.title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 40px;
}

.value-grid {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.value-card {
  flex: 1;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.value-card:hover {
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);
}

.icon-box {
  width: 64px;
  height: 64px;
  background-color: #e0f2fe;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.icon {
  font-size: 24px;
  color: #007bff;
}

.value-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.value-text {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

.back-to-top {
  opacity: 0;
  transition: opacity 0.7s ease-in-out;
}

.show-back-to-top {
  opacity: 1;
}
</style>

<style scoped>
.animated {
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

.fadeIn {
  animation-name: fadeIn;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/main.vue